import { CellEvent, ColumnApi, GridApi } from "ag-grid";
import { AgOverlayTemplate, DropDownItem } from "app/components";
import { UserForSalesManagement } from "app/services/sales.service";


export class NewUserListGridViewModel {

  public gridUsersApi: GridApi;
  public gridUsersColumnApi: ColumnApi;
  public gridUsersParams;
  
  public messageButtonClickCallback: (user: UserForSalesManagement) => void;
  public confirmButtonClickCallback: (userId: number, salesStatusCode: String, salesManagerUserId: number) => void;
  public completeButtonClickCallback: (userId: number, salesManagerUserId: number) => void;
  public deleteButtonClickCallback: (userId: number) => void;
  public openMailFormButtonClickCallback: (user: UserForSalesManagement) => void;
  public openMailHistoryButtonClickCallback: (user: UserForSalesManagement) => void;

  public salesManagersDropdownItems: DropDownItem<number>[] = [];

  static btnClass = 'btn btn-default btn-sm';

  private boolCheckRenderer(param)  {
    if (param.value) {
      let icon = document.createElement("i");
      icon.setAttribute('class', 'ri-check-fill');
      return icon;
    }
  }

  private messageRenderer(param, callback?: (user: UserForSalesManagement) => void) {
    const user: UserForSalesManagement = param.data;

    let button = document.createElement("label");
    let buttonText = "입력";

    if (user.hasMessage) {
      buttonText = "보기";
    }
    button.innerHTML = buttonText;
    button.setAttribute('class', NewUserListGridViewModel.btnClass);
    
    button.addEventListener("click", () => {
      if (callback) {
        callback(user);
      }
    });

    return button;
  }

  
  private salesStatusRenderer(
    param: CellEvent,
    confirmButtonClickCallback: (userId: number, salesStatusCode: String, salesManagerUserId: number) => void,
    completeButtonClickCallback: (userId: number, salesManagerUserId: number) => void,
    deleteButtonClickCallback: (userId: number) => void,
    openMailFormButtonClickCallback: (user: UserForSalesManagement) => void,
    openMailHistoryButtonClickCallback: (user: UserForSalesManagement) => void
    ) {

    const session = JSON.parse(localStorage.getItem('currentUser'));
    const user: UserForSalesManagement = param.data;
    const salesStatusText: string = param.value;
    let salesStatusCode = null;
    if (user && user.salesStatusDetail && user.salesStatusDetail.salesStatusCode) {
      salesStatusCode = user.salesStatusDetail.salesStatusCode;
    }

    if (!salesStatusText) {
      return null;
    }

    let div = document.createElement("div");

    div.innerHTML = salesStatusText;

    if (user.hasHistoryButton) {
      let btnLog = document.createElement("button");
      btnLog.innerHTML = "이력";
      btnLog.setAttribute('class', NewUserListGridViewModel.btnClass);
      btnLog.addEventListener("click", () => {
        if (openMailHistoryButtonClickCallback) {
          openMailHistoryButtonClickCallback(user);
        }
      });
      div.appendChild(btnLog);
    }


    if (user.hasSendEmailButton) {
      let mailBtn = document.createElement("button");
      mailBtn.innerHTML = "발송";
      mailBtn.setAttribute('class', NewUserListGridViewModel.btnClass);
      mailBtn.addEventListener("click", () => {
        if (openMailFormButtonClickCallback) {
          openMailFormButtonClickCallback(user);
        }
      });
      div.appendChild(mailBtn);
    }


    if (user.hasConfirmButton) {
      let confirmBtn = document.createElement("button");
      confirmBtn.innerHTML = "확인";
      confirmBtn.setAttribute('class', NewUserListGridViewModel.btnClass);
      confirmBtn.addEventListener("click", () => {
        if (confirmButtonClickCallback) {
          confirmButtonClickCallback(user.userId, salesStatusCode, session.id);
        }
      });
      div.appendChild(confirmBtn);
    }


    if (user.hasCompleteButton) {
      let btnComplete = document.createElement("button");
      btnComplete.innerHTML = "종료";
      btnComplete.setAttribute('class', NewUserListGridViewModel.btnClass);
      btnComplete.addEventListener("click", () => {
        if (completeButtonClickCallback) {
          completeButtonClickCallback(user.userId, session.id)
        }
      });
      div.appendChild(btnComplete);
    }


    if (user.hasInitButton) {
      let btnInit = document.createElement("button");
      btnInit.innerHTML = "초기화";
      btnInit.setAttribute('class', NewUserListGridViewModel.btnClass);
      btnInit.addEventListener("click", () => {
        if (deleteButtonClickCallback) {
          deleteButtonClickCallback(user.userId);
        }
      });
      div.appendChild(btnInit);
    }

    return div;
  }


  public gridUsersColumnDefinitions = [
    { headerName: "No.", field: "userId", resizable: true, width: 60, sortable: true, filter: 'agTextColumnFilter' },
    { headerName: "이메일", field: "email", resizable: true, width: 200, sortable: true, filter: 'agTextColumnFilter' },
    { headerName: "직업 구분", field: "jobTpText", resizable: true, width: 60, sortable: true, filter: 'agTextColumnFilter' },
    { headerName: "이름", field: "fullName", resizable: true, width: 100, sortable: true, filter: 'agTextColumnFilter' },
    { headerName: "회사명", field: "cmpnyNm", resizable: true, width: 150, sortable: true, filter: 'agTextColumnFilter' },
    { headerName: "휴대전화번호", field: "mobile", resizable: true, width: 120, sortable: true },
    { headerName: "가입 상태", field: "stusText", resizable: true, width: 100, sortable: true, filter: 'agTextColumnFilter' },
    { headerName: "등록일시", field: "regDtLocalTime", resizable: true, width: 180, sortable: true },

    { headerName: "영업담당자", field: "salesManagerName", resizable: true, width: 100, sortable: true, filter: 'agTextColumnFilter',
      // editable: true, singleClickEdit: true,
      // cellEditor: "dropdownEditor", 
      // cellEditorParams: (param) => {return {items: this.salesManagersDropdownItems} }
    },
    { headerName: "고객 상태", field: "salesStatusText", resizable: true, width: 340, sortable: true,
      cellRenderer: (param) => this.salesStatusRenderer(param, this.confirmButtonClickCallback, this.completeButtonClickCallback, this.deleteButtonClickCallback, this.openMailFormButtonClickCallback, this.openMailHistoryButtonClickCallback) },
    { headerName: "물류비견적", field: "cnsltnText", resizable: true, width: 100, sortable: true },
    { headerName: "링고상태", field: "lingoAuthStatusText", resizable: true, width: 80, sortable: true, filter: 'agTextColumnFilter' },
    { headerName: "ShipGo", field: "hasAuthShipgo", resizable: true, width: 70, sortable: true, cellRenderer: this.boolCheckRenderer },
    { headerName: "마지막 발송일", field: "lastEmailSentDtmLocal", resizable: true, width: 180, sortable: true },
    { headerName: "메시지", field: "hasMessage", resizable: true, width: 80, sortable: true, cellRenderer: (param) => this.messageRenderer(param, this.messageButtonClickCallback) },
    { headerName: "전화번호", field: "tel", resizable: true, width: 120, sortable: true },
    { headerName: "FAX", field: "fax", resizable: true, width: 120, sortable: true }
  ];

  public overlayLoadingTemplate = AgOverlayTemplate.overlayProcessingTemplate;

  public rowModelType = "infinite";


  public onGridUsersReady(params) {
    this.gridUsersApi = params.api;
    this.gridUsersParams = params;
    this.gridUsersColumnApi = params.columnApi;
  }

  public showLoadingOverlay() {
    if (this.gridUsersApi) {
      this.gridUsersApi.showLoadingOverlay();
    }
  }

  public hideOverlay() {
    if (this.gridUsersApi) {
      this.gridUsersApi.hideOverlay();
    }
  }

  public rowDataChanged(user: UserForSalesManagement) {
    if (!user) {
      return;
    }

    this.gridUsersApi.forEachNode((rowNode) => {
      let rowData: UserForSalesManagement = rowNode.data as UserForSalesManagement;
      
      if (rowData.userId === user.userId) {
        rowNode.setData(user);
      }
    });

  }


}





// WEBPACK FOOTER //
// ./src/app/containers/user/new-user-list.viewmodel.grid.ts